/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useRef, useLayoutEffect } from 'react';
import usePrevious from './usePrevious';
import PropTypes from 'prop-types';
export const SingleOTPInputComponent = ({ focus, autoFocus, ...rest }) => {
  const inputRef = useRef(null);
  const prevFocus = usePrevious(!!focus);
  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return <input inputMode='numeric' ref={inputRef} {...rest} />;
};
SingleOTPInputComponent.propTypes = {
  autoFocus: PropTypes.bool,
  focus: PropTypes.bool,
};
const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
